import React from "react";
import styles from "../_css/propertiesViewButtonsMobile.module.css";
import clsx from "clsx";
import { SavedSearchButton } from "properties/searchBar/savedSearchButton";
import { PropertiesViewButtonMapList } from "properties/listing/PropertiesViewButtonMapList";

export function PropertiesViewButtonsMobile() {
    return (
        <div className={clsx(styles.container, "flex_row_center justifyContent_center gap_20")}>
            <PropertiesViewButtonMapList />
            <SavedSearchButton />
        </div>
    );
}
